import useGetCurriculumCountryCodeForURL from '~/curriculum/hooks/useGetCurriculumCountryCode'
import ROUTES from '~/shared/constants/routes.const'

export default function useGetGradeOverviewPageRoute({
  grade,
  isOnboarding,
  specificCountryCode,
  topicOrder,
}: {
  grade: string | number
  isOnboarding?: boolean
  specificCountryCode?: string
  topicOrder?: number
}): string {
  const countryCode = useGetCurriculumCountryCodeForURL(specificCountryCode)
  const topicSegment = topicOrder ? `/${topicOrder}` : ''
  return `${isOnboarding ? ROUTES.ONBOARDING : ROUTES.CURRICULUM}/v2/${countryCode}/${grade}${topicSegment}`
}
